import styled from '@emotion/styled';

export const Wrapper = styled.article`
  width: 100%;
  background: ${({ theme, bgColor }) =>
    bgColor ? theme.colors[bgColor] || bgColor : 'transparent'};
`;

export const Content = styled.main`
  width: 100%;
  min-height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContentBody = styled.div`
  width: 100%;
  max-width: 1200px;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  padding-top: ${({ theme: { constants } }) =>
    constants.layout.side.top.desktop};

  padding-left: ${({ theme: { constants } }) =>
    constants.layout.side.leftPadding.desktop};
  padding-right: ${({ theme: { constants } }) =>
    constants.layout.side.leftPadding.desktop};

  padding-bottom: ${({ theme: { spacings } }) => spacings[8]};

  ${({ theme }) => theme.media.tablet} {
    align-items: stretch;
    min-height: ${({ theme, headerType }) =>
      `calc(100vh - ${
        headerType === 'progress'
          ? theme.constants.layout.header.progressHeight
          : theme.constants.layout.header.height
      })`};

    padding-top: ${({ theme: { constants } }) =>
      constants.layout.side.top.tablet};

    padding-left: ${({ theme: { constants } }) =>
      constants.layout.side.leftPadding.tablet};
    padding-right: ${({ theme: { constants } }) =>
      constants.layout.side.leftPadding.tablet};

    padding-bottom: ${({ theme: { spacings } }) => spacings[7]};
  }
  ${({ theme }) => theme.media.mobile} {
    padding-bottom: ${({ theme: { spacings } }) => spacings[6]};
    padding-top: ${({ theme: { constants } }) =>
      constants.layout.side.top.mobile};

    padding-left: ${({ theme: { constants } }) =>
      constants.layout.side.leftPadding.mobile};
    padding-right: ${({ theme: { constants } }) =>
      constants.layout.side.leftPadding.mobile};
  }
`;
